import { render } from "./IconCloseCircle.vue?vue&type=template&id=6dd3d6ee"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCloseCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dd3d6ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dd3d6ee', __exports__)) {
    api.reload('6dd3d6ee', __exports__)
  }
  
  module.hot.accept("./IconCloseCircle.vue?vue&type=template&id=6dd3d6ee", () => {
    api.rerender('6dd3d6ee', render)
  })

}


export default __exports__